module.exports = __webpack_public_path__ + "static/fonts/open-sans-v34-latin-300.6b8abe90.woff";